export default __webpack_public_path__ + "static/media/oman.5bbe1d14.png";